import SuperVisorLayout from "@/layouts/SuperVisor.Layout";

/**
 * Dedicated shell boundary for group members and managers.
 * It intentionally shares the supervisor shell until member-specific UI is designed.
 */
const MemberLayout = (): React.JSX.Element => <SuperVisorLayout />;

export default MemberLayout;
